
export interface ExpenseEntryArchiveClass {
    AccountEmployeeExpenseSheetId: string,
    AccountEmployeeId:number,
    EmployeeName:string,
    ExpenseSheetDate:Date,
    Description:string,
    Amount:number,
    Approved:Boolean,
    Rejected:Boolean,
    Submitted:Boolean,
    isSelected:number,
    AccountId:number,
    
}
export const ExpenseEntryArchiveInitialsForAdd={
    AccountEmployeeId:0,
    EmployeeName:"",
    ExpenseSheetDate:new Date(),
    Description:"",
    Amount:0,
    Approved:false,
    Rejected:false,
    Submitted:false,
    AccountId:0
}

export const ExpenseEntryArchiveInitialsForUpdate={
    AccountEmployeeExpenseSheetId:"",
    AccountEmployeeId:0,
    EmployeeName:"",
    ExpenseSheetDate:new Date(),
    Description:"",
    Amount:0,
    Approved:false,
    Rejected:false,
    Submitted:false,
    AccountId:0
}


